export default __webpack_public_path__ + "static/resume-a6d8f09516435798601ee6ec0149c6e3.pdf";